module.exports = __webpack_public_path__ + "img/plane_track_mobile_1.94360d2a.svg";